/** Shared MeetAI Admin visual tokens — navy/teal system (single source of truth). */
export const ADM = {
  /** Primary teal accent (active states, positive metrics, CTAs, chart highlights) */
  teal: "#0f9d8f",
  tealDark: "#0b7c72",
  tealSoft: "rgba(15,157,143,0.14)",
  /** Soft whisper of green — not a strong mint wash */
  mint: "#F7FAF9",
  mintStrong: "#E8EEEF",
  pageBg: "#f6f8fb",
  card: "#FFFFFF",
  border: "#e3e8ef",
  borderSoft: "#F0F3F6",
  blue: "#2563EB",
  blueSoft: "rgba(37,99,235,0.12)",
  green: "#0f9d8f",
  greenSoft: "rgba(15,157,143,0.14)",
  amber: "#c98a2c",
  amberSoft: "rgba(201,138,44,0.14)",
  violet: "#5B6CFF",
  violetSoft: "rgba(91,108,255,0.12)",
  rose: "#E11D48",
  roseSoft: "rgba(225,29,72,0.12)",
  red: "#b0403f",
  redSoft: "rgba(176,64,63,0.1)",
  text: "#0f1a2b",
  textMuted: "#6b7688",
  textSoft: "#94A3B8",
  radius: 10,
  radiusSm: 8,
  shadow: "none",
  /** legacy aliases used by older calls */
  navy: "#0f9d8f",
  navyMid: "#0b7c72",
  blueBright: "#3B82F6",
};

export const ADM_ICON_TONES = {
  teal: { bg: ADM.tealSoft, fg: ADM.teal },
  blue: { bg: ADM.blueSoft, fg: ADM.blue },
  green: { bg: ADM.greenSoft, fg: ADM.green },
  amber: { bg: ADM.amberSoft, fg: ADM.amber },
  violet: { bg: ADM.violetSoft, fg: ADM.violet },
  rose: { bg: ADM.roseSoft, fg: ADM.rose },
  red: { bg: ADM.redSoft, fg: ADM.red },
  slate: { bg: ADM.borderSoft, fg: ADM.textMuted },
};

export const ADM_CHIP = {
  summarized: { bg: "rgba(15,157,143,0.14)", fg: "#0b7c72" },
  processing: { bg: "rgba(201,138,44,0.14)", fg: "#c98a2c" },
  active: { bg: "rgba(15,157,143,0.14)", fg: "#0b7c72" },
  /** Verified standby — not “unmonitored/insecure” */
  standby: { bg: ADM.borderSoft, fg: ADM.textMuted },
  unmonitored: { bg: ADM.borderSoft, fg: ADM.textMuted },
  error: { bg: "rgba(176,64,63,0.1)", fg: "#b0403f" },
  live: { bg: "rgba(15,157,143,0.14)", fg: "#0b7c72" },
  delivered: { bg: "rgba(15,157,143,0.14)", fg: "#0b7c72" },
};
